import { Layout } from '@repo/types';
import Row from './Row';

export const GeneratePage = ({ rootChildren, rows, columns, components }: Layout) => {
  const rootRows = rootChildren.map((rowId) => rows[rowId]!);
  const tree: Omit<Layout, 'rootChildren'> = {
    rows,
    columns,
    components,
  };

  return (
    <>
      {rootRows.map((row) => (
        <Row key={row.id} id={row.id} tree={tree} />
      ))}
    </>
  );
};
